import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col, InputGroup } from 'react-bootstrap';
import { handleSubmit } from '../utils/AlertsProductos';
import APIserver from '../../../../api/axiosConfig';

function CrearProductoModal({ show, handleClose, fetchProductos }) {
  const [formData, setFormData] = useState({
    referencia: '',
    nombre: '',
    stock: '',
    precioCompra: '',
    precioVenta: '',
    precioMayor: '',
  });

  const checkReferenciaExists = async (referencia) => {
    try {
      const response = await APIserver.post(`/api/productos/verificar-referencia`, { referencia });
      return response.data.exists;
    } catch (error) {
      console.error('Error al verificar la referencia:', error);
      return false;
    }
  };

  const generateUniqueReference = async (baseReference, index) => {
    let newReference;

    if (!isNaN(baseReference)) {
      newReference = (parseInt(baseReference) + index).toString().padStart(baseReference.length, '0');
    } else {
      newReference = `${baseReference}${index}`;
    }

    const exists = await checkReferenciaExists(newReference);
    if (exists) {
      return generateUniqueReference(baseReference, index + 1);
    }

    return newReference;
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const productos = [];
    const formDataToSend = new FormData();

    const uniqueReference = await generateUniqueReference(formData.referencia, 0);

    const stock = parseInt(formData.stock);
    const precioCompra = parseFloat(formData.precioCompra);
    const precioVenta = parseFloat(formData.precioVenta);
    const precioMayor = parseFloat(formData.precioMayor);

    if (
      isNaN(stock) ||
      stock < 0 ||
      isNaN(precioCompra) ||
      precioCompra < 0 ||
      isNaN(precioVenta) ||
      precioVenta < 0 ||
      isNaN(precioMayor) ||
      precioMayor < 0
    ) {
      alert('Por favor ingresa valores válidos para todos los campos.');
      return;
    }

    productos.push({
      referencia: uniqueReference,
      nombre: formData.nombre,
      stock,
      precioCompra,
      precioVenta,
      precioMayor,
    });

    formDataToSend.append('productos', JSON.stringify(productos));

    try {
      await handleSubmit(formDataToSend, handleClose, fetchProductos);
    } catch (error) {
      console.error('Error al enviar los productos:', error);
      alert('Hubo un error al enviar los productos.');
    }
  };

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose} aria-labelledby="example-modal-sizes-title-lg">
        <Modal.Header closeButton>
          <Modal.Title>Crear Nuevos Productos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={onSubmit}>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="m-3 mt-0">
                  <Form.Label>Referencia</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="example-2133"
                    name="referencia"
                    value={formData.referencia}
                    onChange={(e) => setFormData({ ...formData, referencia: e.target.value })}
                    required
                  />
                </Form.Group>
                <Form.Group className="m-3">
                  <Form.Label>Stock</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Cantidad disponible"
                    name="stock"
                    value={formData.stock}
                    onChange={(e) => setFormData({ ...formData, stock: e.target.value })}
                    required
                  />
                </Form.Group>
                <Form.Group className="m-3">
                  <Form.Label>Precio Venta Unidad</Form.Label>
                  <InputGroup className="mb-3">
                    <InputGroup.Text>$</InputGroup.Text>
                    <Form.Control
                      type="number"
                      placeholder="Precio de Venta al público"
                      name="precioVenta"
                      value={formData.precioVenta}
                      onChange={(e) => setFormData({ ...formData, precioVenta: e.target.value })}
                      required
                    />
                    <InputGroup.Text>COP</InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="m-3 mt-0">
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Nombre del producto"
                    name="nombre"
                    value={formData.nombre}
                    onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                    required
                  />
                </Form.Group>
                <Form.Group className="m-3">
                  <Form.Label>Precio Compra</Form.Label>
                  <InputGroup className="mb-3">
                    <InputGroup.Text>$</InputGroup.Text>
                    <Form.Control
                      type="number"
                      placeholder="Precio de compra"
                      name="precioCompra"
                      value={formData.precioCompra}
                      onChange={(e) => setFormData({ ...formData, precioCompra: e.target.value })}
                      required
                    />
                    <InputGroup.Text>COP</InputGroup.Text>
                  </InputGroup>
                </Form.Group>
                <Form.Group className="m-3">
                  <Form.Label>Precio Venta x Mayor</Form.Label>
                  <InputGroup className="mb-3">
                    <InputGroup.Text>$</InputGroup.Text>
                    <Form.Control
                      type="number"
                      placeholder="Precio de Venta al x Mayor"
                      name="precioMayor"
                      value={formData.precioMayor}
                      onChange={(e) => setFormData({ ...formData, precioMayor: e.target.value })}
                      required
                    />
                    <InputGroup.Text>COP</InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Modal.Footer>
              <Button variant="dark" onClick={handleClose}>
                Cancelar
              </Button>
              <Button variant="danger" type="submit">
                Crear Productos
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CrearProductoModal;
